import { IconSVG } from '../types';

export function PlayCircle({ size, style }: IconSVG) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      style={style}
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M10.794 15.365l4.356-2.798a.637.637 0 00.321-.566.642.642 0 00-.321-.568l-4.356-2.798a.616.616 0 00-.69-.037.643.643 0 00-.354.604v5.596c0 .274.118.475.354.604.236.13.466.117.69-.037zm1.208 6.135a9.255 9.255 0 01-3.705-.748 9.598 9.598 0 01-3.018-2.03 9.591 9.591 0 01-2.03-3.016 9.245 9.245 0 01-.749-3.704c0-1.314.25-2.55.748-3.705a9.597 9.597 0 012.03-3.018 9.592 9.592 0 013.016-2.03 9.245 9.245 0 013.704-.749c1.314 0 2.55.25 3.705.748a9.597 9.597 0 013.018 2.03 9.592 9.592 0 012.03 3.016 9.245 9.245 0 01.749 3.704c0 1.314-.25 2.55-.748 3.705a9.598 9.598 0 01-2.03 3.018 9.592 9.592 0 01-3.016 2.03 9.245 9.245 0 01-3.704.749z"
      />
    </svg>
  );
}
